import React from 'react';
import type { Sound } from '../types/database';

interface SoundEmbedProps {
  sound: Sound;
}

export function SoundEmbed({ sound }: SoundEmbedProps) {
  const getEmbedUrl = () => {
    if (sound.provider === 'spotify') {
      // Convert Spotify URL to embed URL
      // Handle both track URLs and already-embed URLs
      if (sound.url.includes('open.spotify.com/embed/')) {
        return sound.url; // Already an embed URL
      }
      
      // Extract track ID from various Spotify URL formats
      let trackId;
      
      // Format: https://open.spotify.com/track/452WSSzuklpg0w4RKTlkvn?si=12bcaa5327374420
      const trackMatch = sound.url.match(/track\/([a-zA-Z0-9]+)/);
      if (trackMatch) {
        trackId = trackMatch[1];
      }
      
      // Format: https://open.spotify.com/intl-de/track/452WSSzuklpg0w4RKTlkvn?si=12bcaa5327374420
      const intlTrackMatch = sound.url.match(/intl-[a-z]+\/track\/([a-zA-Z0-9]+)/);
      if (intlTrackMatch) {
        trackId = intlTrackMatch[1];
      }
      
      if (trackId) {
        return `https://open.spotify.com/embed/track/${trackId}`;
      }
    } else if (sound.provider === 'soundcloud') {
      // Convert SoundCloud URL to embed URL
      return `https://w.soundcloud.com/player/?url=${encodeURIComponent(sound.url)}&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`;
    }
    return null;
  };

  const embedUrl = getEmbedUrl();
  if (!embedUrl) return null;

  return (
    <div className="w-full">
      <iframe
        src={embedUrl}
        width="100%"
        height={sound.provider === 'spotify' ? '80' : '120'}
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        className="rounded-lg"
      />
    </div>
  );
}